import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/svgs/empty.svg'


const _hoisted_1 = { class: "w-full lg:w-1/2 bg-white shadow rounded-2xl lg:p-8 p-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row w-full justify-between items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Candidate status")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "pt-3 w-full space-y-2 lg:space-y-0"
}
const _hoisted_4 = { class: "flex flex-col md:flex-row lg:flex-row w-full justify-center items-center" }
const _hoisted_5 = { class: "flex justify-center items-center rounded-full bg-primary text-white w-12 h-12 p-2" }
const _hoisted_6 = { class: "flex flex-col px-2 w-full text-center lg:text-left md:text-left" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "text-gray-400 leading-none mt-1 text-sm pt-1" }
const _hoisted_9 = { class: "mt-3 lg:mt-0" }
const _hoisted_10 = {
  key: 1,
  class: "flex flex-col justify-center items-center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "160"
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.candidates?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidates, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${i + 1}-candidate-card`,
              class: "flex flex-col md:flex-row lg:flex-row items-center justify-center w-full border border-primary-light lg:border-none md:border-none py-4 lg:py-1 rounded-lg lg:rounded-none"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.getInitials(
                `${item.candidate.first_name} ${item.candidate.last_name}`
              )), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", {
                    onClick: ($event: any) => (_ctx.openJob(item)),
                    class: "leading-none text-sm lg:text-md pt-1 font-bold hover:text-purple-600 cursor-pointer"
                  }, _toDisplayString(`${item.candidate.first_name} ${item.candidate.last_name}`), 9, _hoisted_7),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(item.job.title), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", {
                  style: _normalizeStyle(_ctx.buildColorStep(item.current_stage)),
                  class: "truncate py-1 text-xs lg:text-sm rounded-lg px-2"
                }, _toDisplayString(item.current_stage), 5)
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
  ]))
}